import React from 'react';

import JobDescriptionsStatsLoader from './JobDescriptionsStatsLoader';
import { useJobProspectsStatsState, useJobProspectsStatsActions } from './JobProspectsStatsContext';
import Stack from '../../Shared/UI/Stack/components/Stack';
import PageTitle from '../../Shared/UI/PageTitle/components/PageTitle';
import Button from '../../Shared/UI/Button/components/Button';
import ActionRow from '../../Shared/UI/ActionRow/components/ActionRow';
import { scheduleLineImportanceAnalysis } from './restApi';
import styles from './JobDescriptionsStats.module.scss';

const JobDescriptionsStats = () => {
  const state = useJobProspectsStatsState();
  const { onResponse, onError } = useJobProspectsStatsActions();
  const authenticityToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

  const handleScheduleLineImportance = () => {
    scheduleLineImportanceAnalysis({
      onResponse,
      onError,
      body: {
        authenticity_token: authenticityToken,
      },
    });
  };

  return (
    <>
      <JobDescriptionsStatsLoader />
      <div className={styles.pageLayout}>
        <Stack gap="lg">
          <PageTitle text="Job Descriptions Statistics" />
          <div style={{ marginBottom: '1rem' }}>
            <Button 
              variant="ghost" 
              size="sm"
              onClick={() => window.location.href = '/job_prospects_stats'}
            >
              ← Back to Stats Overview
            </Button>
          </div>
          
          {state?.loading && <p>Loading...</p>}
          
          {state?.feedbackVariant === 'error' && (
            <p style={{ color: 'red' }}>Error: {state?.feedbackMessage}</p>
          )}
          
          {!state?.loading && state?.feedbackVariant !== 'error' && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
              <p><strong>Total Job Descriptions from External Websites:</strong> {state?.total}</p>
              <hr />
              <p><strong>In Pending State:</strong> {state?.pending}</p>
              <p><strong>In Raw Copy Cached State:</strong> {state?.raw_copy_cached}</p>
              <p><strong>In Candidate Specific Text Cached State:</strong> {state?.candidate_specific_text_cached}</p>
              <p><strong>In Candidate Requirements Cached State:</strong> {state?.candidate_requirements_cached}</p>
              <p><strong>In Tags Created State:</strong> {state?.tags_created}</p>
              <p><strong>In Line Importance Analysis Cached State:</strong> {state?.line_importance_analysis_cached}</p>
              <p><strong>Closed:</strong> {state?.closed}</p>
            </div>
          )}
          
          <ActionRow>
            <Button onClick={handleScheduleLineImportance}>
              Schedule Line Importance Analysis
            </Button>
          </ActionRow>
        </Stack>
      </div>
    </>
  );
};

export default JobDescriptionsStats;
